module.exports = __webpack_public_path__ + "static/media/country_bz.3934f2b1.webp";